import api from '@pray/shared/utils/api';

export const markStudioNotificationRead = async ({ artistId = null, notificationId = null } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!notificationId) throw Error('Notification ID is required');

  const url = `/web/studio/artists/${artistId}/notifications/${notificationId}/read`;
  return api.executePutRequest(url);
};
